import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "@windmill/react-ui";
import spinnerLoadingImage from "assets/img/spinner.gif";

const EmailInvoiceModal = ({
  isOpen,
  onClose,
  title = "Email Invoice",
  message = "",
  data,
  onSubmitClick,
  customClass = "",
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setloading] = useState(false);

  // Reset state when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setloading(false);
      setEmail("");
      setError("");
    }

    setEmail(data?.agent_email);
  }, [isOpen, data?.agent_email]);

  const handleCancel = () => {
    setloading(false);
    setEmail(""); // Clear email input
    setError(""); // Clear any error
    onClose(); // Close the modal
  };

  const handleSubmit = () => {
    if (!email.trim()) {
      setError("Email is required!");
      return;
    }
    setError("");
    onSubmitClick(email);
    setloading(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "400px" }}
      className={`relative bg-white dark:bg-gray-700 dark:text-white p-4 w-1/2 rounded-md ${customClass}`}
      aria-labelledby="modal-title"
    >
      <span id="modal-title" className="flex text-xl text-black-500">
        {title}
      </span>
      <ModalBody
        className="text-center custom-modal pt-3 pb-4"
        style={{ margin: "0" }}
      >
        <input
          className="w-full border border-gray-300 rounded py-3 px-2 mt-4 mb-12"
          value={email}
          autoComplete="off"
          onChange={(e) => setEmail(e.target.value)}
        />

        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        <div className="flex items-center justify-around gap-4 mt-8">
          <span
            onClick={handleCancel}
            style={{ color: "red", cursor: "pointer" }}
          >
            Cancel
          </span>

          {loading ? (
            <Button disabled={true} type="button" className=" h-10">
              <img
                src={spinnerLoadingImage}
                alt="Loading"
                width={20}
                height={10}
              />{" "}
              <span className="font-serif ml-2 font-light">Sending</span>
            </Button>
          ) : (
            <button
              disabled={loading}
              onClick={handleSubmit}
              style={{ color: "green", cursor: "pointer" }}
            >
              Send
            </button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default React.memo(EmailInvoiceModal);
